import { Empty as AntEmpty } from 'antd';
import { FileX } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyProps {
  description?: string;
  className?: string;
  image?: React.ReactNode;
}

export function Empty({
  description = '暂无数据',
  className,
  image,
}: EmptyProps) {
  return (
    <AntEmpty
      className={cn('py-16 px-4', className)}
      image={
        image || (
          <div className="flex items-center justify-center">
            <FileX className="h-16 w-16 text-muted-foreground/30" />
          </div>
        )
      }
      description={
        <span className="text-sm text-muted-foreground">{description}</span>
      }
    />
  );
}
